module.exports = __webpack_public_path__ + "static/media/logout.692fa0f7.svg";